import NewsCarousel from "@/components/NewsCarousel.vue";
import Util from "@/ts/Util";
import { Component, Vue } from "vue-property-decorator";

interface LastNews {
  ACTIVE: boolean;
  AUTHOR_ID: number;
  FILEURL: string;
  ID: number;
  IMAGE: string;
  NEWS: string;
  NRORG: number;
  TITLE: string;
}

@Component({
  components: {
    NewsCarousel,
  },
})
export default class NewsDetails extends Vue {
  newsDetail: LastNews =
    JSON.parse(sessionStorage.getItem("NEWS_DETAIL") || "{}") || {};
  homeNews: LastNews[] =
    JSON.parse(sessionStorage.getItem("LAST_NEWS") || "[]") || [];

  mounted() {
    this.getEvent();
  }

  getEvent() {
    const newsDetail = JSON.parse(
      sessionStorage.getItem("NEWS_DETAIL") || "{}"
    );
    this.newsDetail = newsDetail;

    const homeNews = JSON.parse(sessionStorage.getItem("LAST_NEWS") || "[]");
    if (homeNews) {
      this.homeNews = homeNews.filter(
        (homeNew: LastNews) => homeNew.ID != this.newsDetail.ID
      );
    }
  }

  goToHome() {
    const newsIndex = sessionStorage.getItem("CURRENT_NEWS_INDEX");
    const homeLayout = this.verifyRouteHome();
    this.$router.push(homeLayout + "#" + newsIndex);
  }

  verifyRouteHome() {
    const homeLayout: any = Util.verifyRouteHome();
    return homeLayout;
  }

  setNewsDetails(Id: any, index: number) {
    sessionStorage.setItem(
      "NEWS_DETAIL",
      JSON.stringify(this.homeNews.find((news: any) => news.ID == Id))
    );
    sessionStorage.setItem("CURRENT_NEWS_INDEX", String(index));
    this.getEvent();
  }
}
